import { render, staticRenderFns } from "./GraphDetail19.vue?vue&type=template&id=208cbdfe&scoped=true"
import script from "./GraphDetail19.vue?vue&type=script&lang=js"
export * from "./GraphDetail19.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208cbdfe",
  null
  
)

export default component.exports